import { combineReducers } from "redux"
import mistakes from './mistakes';

export default combineReducers(
    {
        mistakes
    }
);